module.exports = __webpack_public_path__ + "84c6810d9752839ff1fbf4ac3079d7ba.png";